import React, { Component, Fragment } from 'react'
import ScrollDrag from '../../../components/site/DragScroll/DragScroll'

import './SliderTestimonialCardStars.scss'



class SliderTestimonialCardStars extends Component {
    constructor(props) {
        super(props);
        this.handleScroll = this.handleScroll.bind(this);
        this.sliderRef = React.createRef();
    }

    getTestimonials() {

        const testimonialList = {
            rafaelKrause: {
                img: "rafael-krause",
                imgAlt: "Rafael A. Krause, Grupo Herbia",
                testimonial:
                    "Tínhamos o desafio de dobrar o faturamento em 12 meses e conseguimos atingir essa meta em apenas 10. O software da Mercos foi crucial para isto.",
                author: "Rafael A. Krause",
                company: "Grupo Herbia",
            },
            gustavoRibeiro: {
                img: "gustavo-ribeiro",
                imgAlt: "Gustavo Ribeiro, Impacttus Cosméticos",
                testimonial:
                    "Desconheço software de vendas igual. Com Mercos elevamos o faturamento em mais 300% em menos de 3 anos.",
                author: "Gustavo Ribeiro",
                company: "Impacttus Cosméticos",
            },
            afonsoTonelli: {
                img: "afonso-tonelli",
                imgAlt: "Afonso Tonelli, Musical Plus",
                testimonial:
                    "Essencial para qualquer representante que quer crescer. Toda minha equipe usa Mercos, melhoramos o atendimento e aumentarmos nosso volume de vendas.",
                author: "Afonso Tonelli",
                company: "Musical Plus",
            },
            felipeAlmeida: {
                img: "felipe-almeida",
                imgAlt: "Felipe Almeida, diretor da HPrime",
                testimonial:
                    "Hoje, os vendedores estão muito mais focados na relação com o cliente e em serem especialistas que ajudam na venda e no pós-venda do que em resolver as minúcias burocráticas de uma tabela, por exemplo",
                author: "Felipe Almeida",
                company: "HPrime",
            },
            joaoPauloOliveira: {
                img: "joao-paulo-oliveira",
                imgAlt: "João Paulo de Oliveira, proprietário Gao Cosméticos",
                testimonial:
                    "Eu pesquisei soluções de mercado e decidi contratar Mercos porque a ferramenta além de ser fácil de usar, me oferece três recursos que meu negócio precisa: e-commerce B2B, força de vendas e indicadores gerenciais",
                author: "João Paulo de Oliveira",
                company: "Gao Cosméticos",
            },
            alexandreSantos: {
                img: "alexandre-santos-delicia-lanches",
                imgAlt: "Alexandre Santos, sócio-proprietário da Delícia Lanches",
                testimonial:
                    "Imagine a nossa felicidade em ganhar produtividade, se adaptar ao mercado e às tendências. Não tem jeito, quem não faz isso perde grandes oportunidades",
                author: "Alexandre Santos",
                company: "Delícia Lanches",
            },
            ronaldoFabbro: {
                img: "ronaldo-fabbro",
                imgAlt: "Ronaldo dal Fabbro, Bake Shop",
                testimonial:
                    "Antes os pedidos eram feitos pelo WhatsApp. Agora nosso cliente compra de forma fácil, rápida e nós não precisamos realizar lançamentos manuais no sistema",
                author: "Ronaldo dal Fabbro",
                company: "Bake Shop",
            },
            francielMartins: {
                img: "franciel",
                imgAlt: "Franciel Martins, ZT Representações",
                testimonial:
                    "O Mercos pra gente foi um divisor de águas na questão da operação. Evoluímos na qualidade dos pedidos, desde a maneira que a gente entrega o pedido pras empresas como na maneira com que a gente gera e monta os pedidos.",
                author: "Franciel Martins",
                company: "ZT Representações",
            },
            marceloSouza: {
                img: "marcelo",
                imgAlt: "Marcelo Souza, Diplomacia Representações",
                testimonial:
                    "Eu usava planilhas de Excel e fichas cadastrais para acessar o histórico do cliente. Hoje eu já não preciso mais perder esse tempo, tudo que eu cadastro no sistema de vendas já vai automaticamente para o e-commerce B2B.",
                author: "Marcelo Souza",
                company: "Diplomacia Representações",
            },
            felipeRodrigues: {
                img: "felipe",
                imgAlt: "Felipe Rodrigues, IF Consultoria e Representações",
                testimonial:
                    "Antes, para o varejista saber detalhes sobre um produto, precisava ligar pro representante, que ligava para a fábrica e retornava a ligação. Hoje, nem enviamos tabelas de preço, mais! Tudo está no Mercos e pode ser acessado e solicitado em segundo.",
                author: "Felipe Rodrigues",
                company: "IF Consultoria e Representações",
            },
            leandroCampos: {
                img: "leandro-campos",
                imgAlt: "Leandro Campos, Gestor Comercial e Marketing",
                testimonial:
                    "O E-commerce B2B é tão intuitivo e fácil de usar quanto o força de vendas. Mostramos aos vendedores como ele poderia ser um aliado valioso, especialmente quando não conseguissem atender o cliente em tempo real devido a estar na estrada ou em visitas.",
                author: "Leandro Campos",
                company: "Gestor Comercial e Marketing",
            },
            henriqueZompeiro: {
                testimonial:
                    <Fragment><strong>A integração foi um grande diferencial</strong>. Estamos com nosso ERP há mais de 15 anos, e ter um força de vendas e e-commerce B2B com <strong>uma integração rápida e prática</strong> só melhorou nossa experiência. Além disso, não afetou nosso fluxo operacional, o que fez com que os colaboradores não tivessem resistência na utilização do Mercos.</Fragment>,
                author: "Henrique Zompeiro",
                company: "Corsa Bike Parts",
            },
            andersonMarques: {
                testimonial:
                    <Fragment><strong>Nossos vendedores reduziram em 70% o tempo na emissão dos pedidos</strong>. Agora tudo acontece em poucos cliques. Com o Mercos integrado ao ERP, tenho controle completo da minha operação, da venda até a gestão da produção. <strong>Ganhei tempo no meu dia a dia para poder olhar para estratégia</strong>.</Fragment>,
                author: "Anderson Marques",
                company: "Keka Alimentos",
            },
            raimysonDias: {
                testimonial:
                    <Fragment>O Mercos facilitou muito para a gente a questão das políticas comerciais e hoje não conseguimos mais viver sem. Trabalhamos estratégias de promoções, ações e condições, conseguimos separar por região, por representante e por cliente. <strong>As tabelas personalizadas trouxeram uma visão mais estratégica e assertiva para nossa gestão de vendas</strong>.</Fragment>,
                author: "Raimyson Dias",
                company: "Esquadromil",
            },
            ronaldoDalFabro: {
                testimonial:
                   <Fragment>O <strong>E-commerce B2B automatizou 100% o nosso processo de tirar pedidos</strong>, principalmente por ser integrado ao ERP. Antes, os pedidos eram feitos pelo WhatsApp. Agora, nosso cliente compra de forma fácil, rápida e nós não precisamos realizar lançamentos manuais no sistema.</Fragment>,
                author: "Ronaldo Dal Fabbro",
                company: "Bake Shop",
            },
        };

        const testimonialsIndustrias = [testimonialList.felipeAlmeida, testimonialList.alexandreSantos];

        const testimonialsRepresentantes = [testimonialList.francielMartins, testimonialList.marceloSouza, testimonialList.felipeRodrigues];

        const testimonialsB2BIndDist = [testimonialList.felipeAlmeida, testimonialList.leandroCampos, testimonialList.alexandreSantos];

        const testimonialsParceiros = [testimonialList.henriqueZompeiro, testimonialList.andersonMarques, testimonialList.raimysonDias, testimonialList.ronaldoDalFabro];

        const testimonialsHome = [
            testimonialList.rafaelKrause,
            testimonialList.gustavoRibeiro,
            testimonialList.afonsoTonelli,
            testimonialList.ronaldoFabbro,
            testimonialList.marceloSouza,
            testimonialList.felipeAlmeida
        ];

        if (this.props.industrias) {
            return testimonialsIndustrias;
        }
        if (this.props.representantes) {
            return testimonialsRepresentantes;
        }
        if (this.props.newHome) {
            return testimonialsHome;
        }
        if (this.props.b2bIndDist) {
            return testimonialsB2BIndDist;
        }
        if (this.props.parceiros) {
            return testimonialsParceiros;
        }

        return testimonialsIndustrias;
    }

    handleScroll(direction) {
        const scrollAmount = 350;
        const sliderElement = this.sliderRef.current.slider.current;

        if (direction === 'left') {
            sliderElement.scroll({
                left: sliderElement.scrollLeft - scrollAmount,
                behavior: 'smooth'
            });
        } else if (direction === 'right') {
            sliderElement.scroll({
                left: sliderElement.scrollLeft + scrollAmount,
                behavior: 'smooth'
            });
        }

        const arrowsElement = sliderElement.parentNode.querySelector('.testimonial-arrows');
        const leftArrow = arrowsElement.querySelector('.testimonial-arrow-left');
        const rightArrow = arrowsElement.querySelector('.testimonial-arrow-right');
        setTimeout(() => {
            if (sliderElement.scrollLeft === 0) {
                leftArrow.classList.add('slider-end');
            } else {
                leftArrow.classList.remove('slider-end');
            }

            if (sliderElement.scrollLeft + sliderElement.clientWidth === sliderElement.scrollWidth) {
                rightArrow.classList.add('slider-end');
            } else {
                rightArrow.classList.remove('slider-end');
            }
        }, 350);
    }

    defaultTestimonials() {
        return (
            <Fragment>
                <div className={`testimonials-title ${this.props.title ? 'testimonials-title-picture-second-title' : ''}`} >
                    <picture>
                        <source srcSet='/images/site/landing-pages/b2b-rep/reps.png' type="image/webp" />
                        <img className='imagem-representantes' src='/images/site/landing-pages/b2b-rep/reps.png' />
                    </picture>
                    {this.props.overtitleUsers && (<div className="label-small  desktop-only">+35 MIL USUÁRIOS </div>)}



                    <div className="testimonials-title-slider-btns">
                        {this.props.title ?
                            <h2 className='font-36 font-bold'>{this.props.title}</h2>
                            : this.props.industrias ?
                                <h2 className='font-36 font-bold'>Indústrias estão conquistando mercados com a Mercos</h2>
                                :
                                <h2 className='font-36 font-bold'>Quem já evoluiu suas vendas com o <br /><nobr>e-commerce</nobr> B2B da Mercos:</h2>
                        }
                        <div className="testimonial-arrows">
                            <div
                                className='testimonial-arrow testimonial-arrow-left slider-end'
                                onClick={() => this.handleScroll('left')}
                            > </div>
                            <div
                                alt=""
                                className='testimonial-arrow testimonial-arrow-right'
                                onClick={() => this.handleScroll('right')}
                            > </div>
                        </div>
                    </div>
                </div>
                <ScrollDrag ref={this.sliderRef} >
                    {this.getTestimonials().map((testimonial) => (
                        <div className="testimonial-card">
                            <div className="testimonial-card-head">
                                <span className="testimonial-card-stars">★★★★★</span>
                            </div>
                            {this.props.descriptionH4 ?
                                <h4 className='testimonial-card-paragraph'>
                                    {testimonial.testimonial}
                                </h4>
                                :
                                <h5 className='testimonial-card-paragraph'>
                                    {testimonial.testimonial}
                                </h5>
                            }
                            <div className="testimonial-card-header">
                                <div className="testimonial-card-author-company">
                                    {testimonial.img && (
                                        <picture>
                                            <source srcSet={"/images/site/depoimentos/" + testimonial.img + ".webp"} />
                                            <img className='profile-image' alt={testimonial.imgAlt} width="50" src={"/images/site/depoimentos/" + testimonial.img + ".jpg"} />
                                        </picture>
                                    )}
                                    <div className="testimonial-author-wrapper">
                                        <h className='testimonial-card-author'>{testimonial.author}</h>
                                        <p className='testimonial-card-company'>{testimonial.company}</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                    ))}

                </ScrollDrag>
            </Fragment>

        )
    }

    render() {
        return (
            <Fragment>
                {this.props.reps ? this.repsTestimonials() : this.props.blackNovember ? this.blacknovTestimonials() : this.defaultTestimonials()}
            </Fragment>
        )
    }
}
export default SliderTestimonialCardStars



// WEBPACK FOOTER //
// /usr/src/site-blog/src/components/site/TestimonialCardStars/SliderTestimonialCardStars.jsx